import { type JSX } from 'react'
import { cn } from '../../utils/cn.js'

interface ToggleSwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  onLabel?: string
  offLabel?: string
  size?: 'sm' | 'md'
}

export default function ToggleSwitch({
  checked,
  onChange,
  disabled = false,
  onLabel = 'Ready',
  offLabel = 'Idle',
  size = 'md',
}: ToggleSwitchProps): JSX.Element {
  return (
    <div className={cn('flex items-center gap-2', disabled && 'opacity-50')}>
      <span
        className={cn(
          'font-semibold transition-colors',
          size === 'sm' ? 'text-[11px]' : 'text-[12px]',
          checked ? 'text-emerald-600' : 'text-slate-500'
        )}
      >
        {offLabel}
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        className={cn(
          'relative inline-flex shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#3366FF] focus:ring-offset-2',
          checked ? 'bg-emerald-500' : 'bg-slate-300',
          size === 'sm' ? 'h-5 w-9' : 'h-6 w-11'
        )}
      >
        <span
          className={cn(
            'pointer-events-none inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
            checked
              ? size === 'sm'
                ? 'translate-x-4'
                : 'translate-x-5'
              : 'translate-x-0',
            size === 'sm' ? 'h-4 w-4' : 'h-5 w-5'
          )}
        />
      </button>
      <span
        className={cn(
          'font-semibold transition-colors',
          size === 'sm' ? 'text-[11px]' : 'text-[12px]',
          checked ? 'text-emerald-600' : 'text-slate-500'
        )}
      >
        {onLabel}
      </span>
    </div>
  )
}
